import { lazy, Suspense } from "react"

import { SkeletonHighProfileVulnerability } from "./SkeletonCollapseHighProfileVulnerability"

import type { HighProfileVulnerabilityProps } from "./HighProfileVulnerability.types"

const HighProfileVulnerabilityComponent = lazy(
  () => import("./HighProfileVulnerabilityComponent")
)

export const HighProfileVulnerability = (
  props: HighProfileVulnerabilityProps
) => (
  <Suspense fallback={<SkeletonHighProfileVulnerability />}>
    <HighProfileVulnerabilityComponent {...props} />
  </Suspense>
)
